import React from 'react';
import { ArrowUpDown } from 'lucide-react';

const Table = ({ columns, data, onSort, sortBy, sortOrder }) => {
  return (
    <div className="w-full overflow-x-auto rounded-2xl border border-slate-100 bg-white/60 shadow-xl backdrop-blur-md">
      <table className="w-full text-left border-collapse">
        <thead>
          <tr className="border-b border-slate-100 bg-white/90 text-xs font-semibold uppercase tracking-wider text-slate-500">
            {columns.map((col, idx) => (
              <th
                key={idx}
                className={`py-4 px-5 ${col.className || ''}`}
              >
                {col.sortable ? (
                  <button
                    onClick={() => onSort && onSort(col.accessor)}
                    className="inline-flex items-center space-x-1.5 hover:text-slate-900 transition group"
                  >
                    <span>{col.header}</span>
                    <ArrowUpDown className={`w-3.5 h-3.5 transition ${sortBy === col.accessor ? 'text-emerald-600' : 'text-slate-600 group-hover:text-slate-500'}`} />
                  </button>
                ) : (
                  col.header
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100 text-sm text-slate-600">
          {data.map((row, rowIndex) => (
            <tr
              key={row._id || rowIndex}
              className="hover:bg-slate-50/40 transition duration-150 group"
            >
              {columns.map((col, colIndex) => (
                <td key={colIndex} className={`py-4 px-5 ${col.cellClassName || ''}`}>
                  {col.cell ? col.cell(row, rowIndex) : row[col.accessor]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
